const EventArg = ({label, value}: {label: string; value: any}) => {
	return (
		<div className="flex flex-row justify-between pb-2">
			<span className="font-semibold">{label}:</span>
			<span>{value}</span>
		</div>
	)
}

export default EventArg
